<template>
	<nav class="navbar is-primary" role="navigation" aria-label="main navigation">
		<div class="navbar-brand">
			<router-link to="/" class="navbar-item">
				<h1>{{ title }}</h1>
			</router-link>
		</div>
		<div class="navbar-end">
			<a class="navbar-item" @click="logout">Logout</a>
		</div>
	</nav>
</template>

<script>
import firebase from 'firebase'
import AboutModal from './AboutModal'

export default {
	name: 'navigation',
	props: ['title'],
	components: {
		AboutModal
	},
	data() {
		return {
			showAboutModal: false
		}
	},

	methods: {
		logout () {
			firebase.auth().signOut().then(() => {
				this.$router.replace('login')
			})
		}
	}
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Navigation.vue